import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/en.json";
import it from "./locales/it/it.json";
import pl from "./locales/pl/pl.json";
const resources = { en: { translation: en }, it: { translation: it }, pl: { translation: pl } };

i18n.use(initReactI18next).init({
  resources,
  lng: "it",
  interpolation: { escapeValue: false },
});

export default i18n;
